<style lang="less" scoped>
</style>

<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">{{pageTitle}}</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" label-width="120px" class="detail-form">
                    <div class="flex detail-form-parent-div">
                        <div class="flex-1">
                            <el-form-item label="运营商">
                                <el-input v-model="detailForm.dealName" size="small" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="所属电站">
                                <el-input v-model="detailForm.stationName" size="small" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="电站编号">
                                <el-input v-model="detailForm.stationNo" size="small" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="充电桩编号">
                                <el-input v-model="detailForm.pileCode" size="small" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="申请原因" prop="applyReason">
                                <el-input v-model="detailForm.applyReason" size="small" type="textarea"></el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-1"></div>
                    </div>
                </el-form>
            </div>
            <div class="detail-content-footer-div">
                <button class="common-bg-button" @click="submitForm('detailForm')">提 交</button>
                <button class="common-empty-button" @click="resetForm">取 消</button>
            </div>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    import dateUtil from '@/utils/dateUtils';
    export default {
        data() {
            return {
                pageConfig,
                editFlag:false,
                pageTitle:'充电桩维修新增',
                // 默认值设置
                detailForm: {},
                userInfo:{},
                repairObj:{},
            }
        },
        methods: {
            init() {
                this.userInfo = this.$store.state.userInfo;
                this.repairObj = this.$store.state.repairObj;
                if(this.repairObj){
                    // this.editFlag = true;
                    this.getFormInfo();
                }
            },
            // 获取表单信息
            getFormInfo(){
                let _ = this;
                _.$S.getFormInfo(_,_.$A.pile.list +'/'+_.repairObj.id,function(res){
                     _.detailForm = res.data.data;
                });
            },
            // 表单提交
            submitForm(formName) {
                let _ = this;
                let date = new Date();
                let applyTime = dateUtil.format(date,'Y-M-D H:m:s');
                _.detailForm.applyTime  = applyTime;
                _.detailForm.applyPerson  = _.userInfo.userName;
                _.detailForm.applyPhone  = _.userInfo.userPhone;
                _.detailForm.corpNo = _.$store.state.corpNo;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        _.$S.submitForm(_, _.$A.pile.pilerepair, _.editFlag, _.detailForm, pageConfig.repairListDetail);
                    }
                });
            },
            // 取消
            resetForm() {
                this.$router.push({
                    name: pageConfig.listRouter
                })
            }
        },
        mounted() {
            this.init();
        }
    }
</script>